import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import hi from "./locales/hi.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";

export const SUPPORTED_LANGS = [
    { code: "en", label: "English", short: "EN" },
    { code: "hi", label: "हिन्दी", short: "HI" },
    { code: "fr", label: "Français", short: "FR" },
    { code: "de", label: "Deutsch", short: "DE" },
];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            hi: { translation: hi },
            fr: { translation: fr },
            de: { translation: de },
        },
        fallbackLng: "en",
        supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
        interpolation: { escapeValue: false }, // React already escapes
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
            lookupLocalStorage: "met_lang",
        },
    });

export default i18n;
